import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { AuthWrapper, AuthSubmit, EmailInput, PasswordInput, AuthFormHeader, ForgotPasswordLink } from '@src/features/auth/components';
import { useSignInForm } from '@src/features/auth/hooks';
import { REQUIRED_VALIDATION_TEXT } from '@src/core/config';
import { ArcStack, ArcText } from '@src/core/ui';

const SignInPage: React.FC = () => {
  const { register, formState: { errors }, onSubmit, isLoading } = useSignInForm();
  const { t } = useTranslation();
  // Set by the verify-TOTP step when the challenge token expires / is invalid.
  // The verify step passes a translation key so the message is localized here, at
  // the point of display.
  const location = useLocation();
  const mfaMessageKey = (location.state as { mfaMessageKey?: string } | null)?.mfaMessageKey;
  const mfaMessage = mfaMessageKey ? t(mfaMessageKey) : undefined;

  return (
    <AuthWrapper>
      <AuthFormHeader
        title='Welcome'
        subtitle='Enter your email and password to proceed'
      />
      {mfaMessage && (
        <ArcText mt={2} fontSize={14} color='error.main' textAlign='center'>
          {mfaMessage}
        </ArcText>
      )}
      <ArcStack component='form' mt={3} gap={1} onSubmit={onSubmit}>
        <EmailInput
          register={register('email', { required: REQUIRED_VALIDATION_TEXT })}
          error={errors.email}
        />
        <PasswordInput
          register={register('password', { required: REQUIRED_VALIDATION_TEXT })}
          error={errors.password}
        />
        <ForgotPasswordLink />
        <AuthSubmit
          buttonText='SIGN IN'
          isLoading={isLoading}
        />
      </ArcStack>
    </AuthWrapper>
  );
};

export default SignInPage;